export default __webpack_public_path__ + "static/media/014-placeholder.9a9e21e5.png";